import {createAction, props} from "@ngrx/store";
import {HttpErrorResponse} from "@angular/common/http";
import {EventComment, EventCommentRequest, EventItem, EventSearchParams} from '@communication/_common/models/events.models';
import {DahLoadingType} from '@common/components-module/core-components.models';
import {DahPaginationModel} from '@common/models/commonHTTP.models';

// <editor-fold desc="Events list">
export const CheckState = createAction(
    '[Events] Check State',
    props<{ payload: { modalView: boolean, close: boolean, items: EventItem[] } }>()
);

export const CheckStateSuccess = createAction(
    '[Events] Check State Success',
    props<{ payload: { modalView: boolean, close: boolean, items: EventItem[] } }>()
);

export const LoadList = createAction(
    '[Events] Load List',
    props<{ payload: { loading: DahLoadingType, clearState: boolean } }>()
);

export const LoadListSuccess = createAction(
    '[Events] Load List Success',
    props<{ payload: { items: EventItem[], pagination: DahPaginationModel, clearState: boolean } }>()
);

export const LoadListFailure = createAction(
    '[Events] Load List Failure',
    props<{ payload: HttpErrorResponse }>()
);

export const SetPagination = createAction(
    '[Events] Set Pagination',
    props<{ payload: boolean }>()
);

export const SetFilter = createAction(
    '[Events] Set Filter',
    props<{ payload: EventSearchParams }>()
);

export const SetLoading = createAction(
    '[Events] Set Loading',
    props<{ payload: DahLoadingType }>()
);

export const SetItemsLoading = createAction(
    '[Events] Set Items Loading',
    props<{ payload: { id: string, isStart: boolean } }>()
);

// </editor-fold desc="Events list">

// <editor-fold desc="Event item">

export const UpdateItemSuccess = createAction(
    '[Events] Update Item Success',
    props<{ payload: EventItem }>()
);

export const DeleteItem = createAction(
    '[Events] Delete Item',
    props<{ payload: EventItem }>()
);

export const DeleteItemSuccess = createAction(
    '[Events] Delete Item Success',
    props<{ payload: EventItem }>()
);

export const SetOpenedItem = createAction(
    '[Events] Set Opened Item',
    props<{ payload: EventItem }>()
);

export const ClearOpenedItem = createAction(
    '[Events] Clear Opened Item'
);

export const UpdateOpenedItem = createAction(
    '[Events] Update Opened Item',
    props<{ payload: EventItem }>()
);

// </editor-fold desc="Event item">

// <editor-fold desc="Event comments">
export const LoadComments = createAction(
    '[Events] Load Comments',
    props<{ payload: { eventId: string, loading: DahLoadingType } }>()
);

export const LoadCommentsSuccess = createAction(
    '[Events] Load Comments Success',
    props<{ payload: { comments: EventComment<any>[], pagination: DahPaginationModel } }>()
);

export const LoadCommentsFailure = createAction(
    '[Events] Load Comments Failure',
    props<{ payload: HttpErrorResponse }>()
);

export const SendComment = createAction(
    '[Events] Send Comment',
    props<{ payload: { event: EventItem, comment: EventCommentRequest } }>()
);

export const SendCommentSuccess = createAction(
    '[Events] Send Comment Success',
    props<{ payload: EventComment<any> }>()
);

export const SendCommentFailure = createAction(
    '[Events] Send Comment Failure',
    props<{ payload: HttpErrorResponse }>()
);

export const UpdateCommentSuccess = createAction(
    '[Events] Update Comment Success',
    props<{ payload: EventComment<any> }>()
);

export const DeleteComment = createAction(
    '[Events] Delete Comment',
    props<{ payload: { event: EventItem, comment: EventComment<any> } }>()
);

export const DeleteCommentSuccess = createAction(
    '[Events] Delete Comment Success',
    props<{ payload: EventComment<any> }>()
);

export const CheckAndChangeLastComment = createAction(
    '[Events] Check And Change Last Comment',
    props<{ payload: { event: EventItem, comment: EventComment<any> } }>()
);

export const SetCommentItemsLoading = createAction(
    '[Events] Set Comment Items Loading',
    props<{ payload: { id: string, isStart: boolean } }>()
);

export const SetCommentLike = createAction(
    '[Events] Set Comment Like',
    props<{ payload: { event: EventItem, comment: EventComment<any> } }>()
);

// </editor-fold>

export const SetInitialState = createAction(
    '[Events] Set Initial State'
);
